import { configureStore } from '@reduxjs/toolkit'

import monitorReducersEnhancer from './enhancers/monitorReducer'
import loggerMiddleware from './middleware/logger'
import counterReducer from './reducers/familiesReducer'
import populationReducer from './reducers/populationReducer'
import schoolsReducer from './reducers/schoolsReducer'
import streetsReducer from './reducers/streetsReducer'
import langReducer from './reducers/langReducer'
import loaderReducer from './reducers/loaderReducer'
import recentDocuments from './reducers/recentDocumentsReducer'
import recentPosters from './reducers/recentPostersReducer'
import booksReducer from './reducers/booksReducer'
import raznoReducer from './reducers/raznoReducer'
import mediaReducer from './reducers/mediaReducer'
import svedocenjaReducer from './reducers/svedocenjaReducer'
import imagesReducer from './reducers/imagesReducer'
import groupsReducer from './reducers/groupsReducer'
import documentsReducer from './reducers/documentsReducer'
import membersReducer from './reducers/membersReducer'
import gridReducer from './reducers/gridReducer'
import housebyhouse from './reducers/houseByHouseReducer'
import housebypopulation from './reducers/houseByPopulationReducer'
import housebyschool from './reducers/houseBySchoolReducer'
import wallpapersWide from './reducers/wallpapersWideReducer'
import wallpapersNarrow from './reducers/wallpapersNarrowReducer'

import personDetailsReducer from './reducers/personDetailsReducer'
import familyDetailsReducer from './reducers/familyDetailsReducer'

import notesReducer from './reducers/notesReducer'


export default function configureAppStore(preloadedState) {
  const store = configureStore({
    reducer: {
      
      families:counterReducer,
      population:populationReducer,
      streets:streetsReducer,
      schools:schoolsReducer,
      lang:langReducer,
      loader:loaderReducer,

      recentDocuments:recentDocuments,
      books:booksReducer,
      razno:raznoReducer,
      media:mediaReducer,
      svedocenja:svedocenjaReducer,
      images:imagesReducer,
      documents:documentsReducer,
      recentPosters:recentPosters,
      groups: groupsReducer,
      grid:gridReducer,

      housebyhouse:housebyhouse,
      housebypopulation:housebypopulation,
      housebyschool:housebyschool,

      members:membersReducer,

      wallpapersNarrow:wallpapersNarrow,
      wallpapersWide:wallpapersWide,

      personDetails: personDetailsReducer,
      familyDetails: familyDetailsReducer,  
      notes: notesReducer,

    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().prepend(loggerMiddleware),
    preloadedState,
    // enhancers: [monitorReducersEnhancer]
  })

  // if (process.env.NODE_ENV !== 'production' && module.hot) {
  //   module.hot.accept('./reducers', () => store.replaceReducer(rootReducer))
  // }

  return store
}